import { loadAlpineAsync } from '@/src/utilities/script-loader';

export async function load() {
  if (!document.querySelector('[data-app="product-detail"]')) {
    return;
  }

  const Alpine = await loadAlpineAsync();

  Alpine.data('productDetail', () => ({
    litSearch: '',
    ...window.productDetail,

    filterLiterature,
  }));

  Alpine.start();

  /**
   * @this {ProductDetailState}
   * @param {string} value
   */
  function filterLiterature(value) {
    value = value.toLowerCase();

    for (const g of this.literatureGroups) {
      let groupVisible = false;
      for (const l of g.literature) {
        if (!value || l.title.toLowerCase().includes(value)) {
          l.isVisible = true;
          groupVisible = true; // If at least one item is visible, then the group is visible
        } else {
          l.isVisible = false;
        }
      }
      g.isVisible = groupVisible;
    }
  }
}

/**
 * @typedef ProductDetailState
 * @property {LiteratureGroup[]} literatureGroups
 * @property {number} literatureCount
 * @property {string} litSearch
 */

/**
 * @typedef LiteratureGroup
 * @property {number} nodeId
 * @property {string} title
 * @property {Literature[]} literature
 * @property {boolean} isVisible
 */

/**
 * @typedef Literature
 * @property {string} id
 * @property {string} title
 * @property {boolean} isVisible
 * @property {Date} date
 * @property {number} sizeBytes
 * @property {string} revision
 */
